import { useState } from 'react';
import { Modal, Form, Input, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { uploadFile } from '../../../../apis/OdooMovimientoEmpleadoApi';

const ModalComprobanteUploadFiles = ({ title, open, finish, odoo_movimiento }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [comprobanteFile, setComprobanteFile] = useState(null);
  const [comprobanteFileName, setComprobanteFileName] = useState(null);

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };


  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Convertir archivos a Base64
      const comprobanteBase64 = await fileToBase64(comprobanteFile);

      // Preparar payload para el backend
      const payload = {
        odoo_empleado_id: odoo_movimiento.odoo_empleado_id,
        type: "pago",
        file_base64: comprobanteBase64.split(',')[1], // Quitar el prefijo data:...
        filename: comprobanteFileName
      };

      // Llamar al servicio de API
      const response = await uploadFile(payload);
      
      if (response.ok) {
        message.success('Comprobante subido correctamente');
        finish(true); // Cierra el modal y refresca los datos
      } else {
        throw new Error(response.message || 'Error al subir el comprobante');
      }
    } catch (error) {
      console.error('Error:', error);
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const beforeUpload = (file, type) => {
    setComprobanteFile(file);
    setComprobanteFileName(file.name);
    return false;
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={() => finish(false)}
      footer={null}
      width={600}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Comprobante de pago"
          required
        >
          <Upload
            beforeUpload={(file) => beforeUpload(file)}
            maxCount={1}
            fileList={comprobanteFile ? [comprobanteFile] : []}
            onRemove={() => setComprobanteFile(null)}
          >
            <Button icon={<UploadOutlined />}>Seleccionar archivo .PDF o PNG</Button>
          </Upload>
        </Form.Item>

        <Form.Item>
          <Button 
            type="primary" 
            htmlType="submit" 
            loading={loading}
            disabled={!comprobanteFile}
            block
          >
            Subir Archivos
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalComprobanteUploadFiles;